import * as React from 'react';

import { ContactButtons } from '../../components/ContactButtonsRedesigned';
import { CallRedesigned } from '../Call';
import { trackShowPhone } from './tracking';
import { CallbackButtonContainer } from '../CallbackButtonRedesigned';

export function ContactButtonsContainer() {
  return (
    <ContactButtons
      callButton={<CallRedesigned onShowPhone={trackShowPhone('CallBack_popup_open_headblock')} />}
      callbackButton={<CallbackButtonContainer fullWidth size="M" theme="fill_secondary" place="headblock" />}
    />
  );
}
